import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { Message } from "element-ui";
import { ACCESS_TOKEN } from "@/store/mutation-types"
import { ACCESS_SECRET } from '../store/mutation-types'
import {getFrontConfig, utils} from 'ow-service-component'
// 创建 axios 实例
const service = axios.create({
  timeout: 15000 // 请求超时时间
})

// 一直等待的axios实例
const longService = axios.create({
})

// 创建 axios 实例
const implService = axios.create({
  // baseURL: '/cloudApi', // api base_url
  timeout: 15000 // 请求超时时间
})

// 创建 getway 实例
const gatewayService = axios.create({
  // baseURL: getFrontConfig().GATEWAY_API, // api base_url
  timeout: 15000 // 请求超时时间
})
const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log("------异常响应------", token)
    console.log("------异常响应------", error.response.status)
    switch (error.response.status) {
      case 403:
        Message.error("拒绝访问")
        break
      case 500:
        Message.warning("很抱歉，登录已过期，请重新登录")
        store.dispatch('Logout').then(() => {
          Vue.ls.remove(ACCESS_TOKEN)
          window.location.reload()
        })
        break
      case 404:
        Message.error("很抱歉，资源未找到!")
        break
      case 504:
        Message.error("网络超时")
        break
      case 401:
        Message.error("未授权，请重新登录")
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        Message.warning(data.message)
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  // console.log(getFrontConfig().XZYD_API)
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    // config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    config.headers['ow_token'] = token
  }
  const secret = Vue.ls.get(ACCESS_SECRET)
  if (secret) {
    config.headers['ow_secret'] = secret
  }
  if (config.method == 'get') {
    if (config.url.indexOf("sys/dict/getDictItems") < 0) {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
  }
  config.url = utils.axiosUtils.concatUrl(getFrontConfig().XZYD_API, config.url)
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

longService.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['ow_token'] = token
    const secret = Vue.ls.get(ACCESS_SECRET)
    config.headers['ow_secret'] = secret
  }
  if (config.method == 'get') {
    if (config.url.indexOf("sys/dict/getDictItems") < 0) {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
  }
  config.url = utils.axiosUtils.concatUrl(getFrontConfig().XZYD_API, config.url)
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
longService.interceptors.response.use((response) => {
  return response.data
}, err)


// gateway
gatewayService.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['ow_token'] = token
    const secret = Vue.ls.get(ACCESS_SECRET)
    config.headers['ow_secret'] = secret
  }
  config.url = utils.axiosUtils.concatUrl(getFrontConfig().GATEWAY_API, config.url)
  return config
}, (error) => {
  return Promise.reject(error)
})
gatewayService.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service, implService, gatewayService)
  }
}

export {
  installer as VueAxios,
  service as axios,
  longService as longAxios,
  implService as implAxios,
  gatewayService as gateWayAxios,
}